<div>
  <div class="scaffold-editor-panel">
    <!-- {{undos|json}} -->
    <div class="inline-block">
      <p-button varient="text" severity="info" (click)="undo()" [disabled]="undos.length < 2 || undoLevel === 0" aria-label="Undo scaffold editor"><i class="fas fa-undo"></i></p-button>
      <p-button varient="text" severity="info" (click)="redo()" [disabled]="undoLevel + 1 === undos.length" aria-label="Redo scaffold editor"><i class="fas fa-redo"></i></p-button>

    </div>
    <div class="inline-block" *ngIf="templates">
      <div class="underline margin-left" style="margin:0 20px;">Templates</div>
      <ul class="inline-list" style="margin:0;">
        <li *ngFor="let template of templates" (click)="setTemplate(template.content)" [title]="template.title">
          <div class="template-item-content">
            <app-view-icon *ngFor="let it of template.content | slice:0:5; let i=index" [item]="it"></app-view-icon>
          </div>
        </li>
      </ul>
    </div>
    <div class="scaffold-editor-content">
      <div class="scaffold-add-buttons scaffold-before-buttons" (mouseover)="last_hovered = true" (mouseout)="last_hovered = false" [ngClass]="{'button-menu-hovered':last_hovered}">
        <hr class="line-highlight" />
        <div class="add-new-menu">
          <div class="btw-button-holder">
            <button pButton [rounded]="true" size="small" severity="primary" (click)="openDialog()" class="scaffold-list-insert add-new-item" pTooltip="Add Component" aria-label="Add Component" tooltipPosition="top" *ngIf="!movingItem.selectedItem"><span><i class="fas fa-plus"></i></span></button>
          </div>
        </div>

        <div class="btw-button-holder">
          <button pButton (click)="moveItem()" class="scaffold-list-insert" severity="info" *ngIf="movingItem.selectedItem">Insert</button>
        </div>
      </div>
      <div class="add-placeholder"><div class="color-bar"></div></div>
      <app-items [info]="info" (deleteItem)="deleteHandler($event, items)" (addItem)="addHandler($event, it, items)" *ngFor="let it of items" [item]="it" [arr]="items" [toCreateItems]="extraItemsForTemplate" (itemChanged)="scaffoldChange($event)" [parents]="parents" [undoService]="undoService"></app-items>
    </div>
  </div>
</div>

